module.exports = __webpack_public_path__ + "img/cover-pt.866431ab.png";